<template>
    <div>
        <!-- 韩国(KOR)进口提单明细/出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th>公司名称</th>
                        <td colspan="3">{{billInfo.CompanyName}}</td>
                    </tr>
                    <tr>
                        <th width="25%">公司代码</th>
                        <td width="25%">{{billInfo.CompanyCode}}</td>
                        <th width="25%">行业</th>
                        <td width="25%">{{billInfo.Industry}}</td>
                    </tr>
                    <tr>
                        <th>地址</th>
                        <td>{{billInfo.Address}}</td>
                        <th>办事处</th>
                        <td>{{billInfo.Office}}</td>
                    </tr>
                    <tr>
                        <th>制造商</th>
                        <td>{{billInfo.Manufacturer}}</td>
                        <th>制造国</th>
                        <td>{{billInfo.ManufacturerCountry}}</td>
                    </tr>
                    <tr>
                        <th>出口国</th>
                        <td>{{billInfo.Country}}</td>
                        <th>分类</th>
                        <td>{{billInfo.Class}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>